import { DragOverlay } from "@dnd-kit/core";
import { ArrowDownward, ArrowUpward } from "@mui/icons-material";
import { Chip, Divider, SxProps, Theme } from "@mui/material";

export type ListDragOverlayProps = {
    sx?: SxProps<Theme>
};


export default function ListDragOverlay({
    sx
}: ListDragOverlayProps) {
    return (
        <DragOverlay
            dropAnimation={{
                duration: 0
            }}
            style={{
                touchAction: "none",
                cursor: "pointer",
            }}>
            <Divider
                sx={{
                    position: "relative",
                    top: "50%",
                    transform: "translate(0, -50%)",
                    ...sx
                }}
            >
                <Chip label={
                    <>
                        <ArrowDownward sx={{ marginTop: 1 }} />
                        <ArrowUpward sx={{ marginTop: 1 }} />
                    </>
                } />
            </Divider>
        </DragOverlay>
    );
}
